export default {"src":"/_next/static/media/stagebuilder.247f9dee.gif","height":474,"width":566,"blurWidth":0,"blurHeight":0};